var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourRateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99991 8.5H3.23598C1.74922 8.5 0.782223 10.0646 1.44712 11.3944L4.94712 18.3944C5.28591 19.072 5.97843 19.5 6.73598 19.5H10.7537C10.9172 19.5 11.0801 19.4799 11.2388 19.4403L14.9999 18.5M7.99991 8.5V3.5C7.99991 2.39543 8.89534 1.5 9.99991 1.5H10.0954C10.5949 1.5 10.9999 1.90497 10.9999 2.40453C10.9999 3.11883 11.2113 3.81715 11.6076 4.41149L14.9999 9.5V18.5M7.99991 8.5H9.99991M14.9999 18.5H16.9999C18.1045 18.5 18.9999 17.6046 18.9999 16.5V10.5C18.9999 9.39543 18.1045 8.5 16.9999 8.5H14.4999",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourRateActive);
export default __webpack_public_path__ + "static/media/fourRateActive.9c199efcf0f93cfb2f17996d73ddce3d.svg";
export { ForwardRef as ReactComponent };